<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required, maxLength } from "vuelidate/lib/validators";
import PrexcClassification from '@/components/modals/prexc-classification.vue';
import OutcomeModal from "@/components/modals/outcome.vue"

export default {
    name: "ProgramArea",
    components: {
        PrexcClassification,
        OutcomeModal
    },
    data() {
        return {
            submitted: false,
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "prexcName",
            sortDesc: false,
            prexc: {
                id: 0,
                uacs: "",
                prexcName: "",
                prexcClassification: {
                    classification: ""
                },
                outcome: {
                    outcomeName: ""
                },
                prexcClassificationId: null,
                outcomeId: null,
            },
            indexSelected: -1,
            tableBusy: false,
            categories: [],
        };
    },
    computed: {
        rows() {
            if(this.filter && this.filter.trim() !== ""){
                return this.totalRows;
            }
            return this.tableData.length;
        },
        fields(){
            let arr = [
                {
                    key: "prexcName",
                    label: "Program Area",
                    sortable: true,
                },
            ];
            if(this.$store.state.decrypt.isAdmin()){
                arr.push({
                    key: "actions",
                    thStyle: { width: "90px" },
                })
            }
            return arr;
        }
    },
    validations: {
        prexc: {
            prexcName: { required, maxLength: maxLength(500) },
            prexcClassificationId: { required },
            outcomeId: { required },
        },
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        addPa() {
            this.onReset();
            this.modalTitle = "Create New Program Area";
            this.$bvModal.show("pa-modal");
        },
        onReset() {
            this.prexc = {
                id: 0,
                uacs: "",
                prexcName: "",
                prexcClassification: {
                    classification: ""
                },
                outcome: {
                    outcomeName: ""
                },
                prexcClassificationId: null,
                outcomeId: null,
            };
        },
        hideModal() {
            this.$bvModal.hide("pa-modal");
        },
        updateItem(props) {
            this.prexc = cloneDeep(props.item);
            this.modalTitle = "Update New Program Area";
            this.$bvModal.show("prexc-modal");
            this.$bvModal.show("pa-modal");
        },
        deleteItem(props) {
            console.log(props.item)
            var index = this.tableData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.value) {
                    await this.$store
                        .dispatch(
                            "prexc/DeletePrexc",
                            props.item.id
                        )
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage,"error");
                            }
                            this.tableData.splice(index, 1);
                            this.showToast("Successfully deleted!","success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!","error");
                        });
                }
            });
        },
        async getData(){
            this.tableBusy = true;
            await this.getAllPrexcs();
            this.tableBusy = false;
        },
        async getAllPrexcs(){
            await this.$store
                .dispatch("prexc/GetPrexc")
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage,"error");
                    }
                    this.tableData = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!","error");
                });
        },
        dropData(data) {
            this.$emit("dropData", data[0]);
            this.$bvModal.hide("program-area-modal");
        },
        getPa(){
            this.$refs.pModal.getData();
            this.$bvModal.show('prexc-classification-modal');
        },
        dropPrexcClass(data){
            this.prexc.prexcClassificationId = data.id;
            this.prexc.prexcClassification = data;
        },
        onCreatePrexc(){
            this.submitted = true;
            this.$v.prexc.$touch();
            if (this.$v.prexc.$invalid) {
                return;
            }
            if (this.prexc.id > 0) {
                this.$store
                    .dispatch("prexc/UpdatePrexc", this.prexc)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        let index = this.tableData.findIndex(x => x.id == this.prexc.id)
                        this.tableData.splice(index, 1, res.data);
                        this.$bvModal.hide("pa-modal");
                        this.showToast("Successfully updated!","success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!","error");
                    });
            } else {
                this.$store
                    .dispatch("prexc/CreatePrexc", this.prexc)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        this.tableData.push(res.data)
                        this.$bvModal.hide("pa-modal");
                        this.showToast("Successfully created!","success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!","error");
                    });
            }
            this.submitted = false;
        },
        deletePrexc(row){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("prexc/DeletePrexc", row.id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, 'error');
                            }
                            let index = this.tableData.findIndex(x => x.id == row.id)
                            this.tableData.splice(index, 1);
                            this.showToast("Successfully deleted!","success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!","error");
                        });
                }
            });
        },
        getOM(){
            this.$refs.outcomeModal.getData();
            this.$bvModal.show('outcome-modal')
        },
        dropOutcome(data){
            this.prexc.outcome = data;
            this.prexc.outcomeId = data.id;
        }
    },
};
</script>

<template>
    <b-modal
        id="program-area-modal"
        title="Program Area List"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="row mt-1">
            <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter">
                    <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            autocomplete="off"
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                        ></b-form-input>
                    </label>
                </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
                <div class="d-flex justify-content-end align-items-center">
                    <button
                        v-if="$store.state.decrypt.isAdmin()"
                        type="button"
                        @click="addPa()"
                        class="btn btn-sm btn-info d-flex align-items-center"
                    >
                        <i class="bx bx-plus fs-6"></i>Create New
                    </button>
                    <b-modal
                        id="pa-modal"
                        :title="modalTitle"
                        size="md"
                        title-class="font-18"
                        hide-footer
                        no-close-on-backdrop
                    >
                        <form
                            @submit.prevent="onCreatePrexc"
                            class="needs-validation"
                            ref="fcForm"
                        >
                            <div class="mb-3">
                                <label for="prexcName">UACS Code</label>
                                <input
                                    autocomplete="off"
                                    type="text"
                                    placeholder="Enter UACS Code..."
                                    class="form-control"
                                    v-model="prexc.uacs"
                                />
                            </div>
                            <div class="mb-3">
                                <label for="prexcName">Program Area Name</label>
                                <textarea
                                    id="prexcName"
                                    rows="3"
                                    v-model="prexc.prexcName"
                                    placeholder="Enter Program Area Name..."
                                    class="form-control"
                                    :class="{'is-invalid': submitted && $v.prexc.prexcName.$error}"
                                ></textarea>
                                <div v-if="submitted && $v.prexc.prexcName.$error" class="invalid-feedback">
                                    <span v-if="!$v.prexc.prexcName.required">This value is required.</span>
                                    <span v-if="!$v.prexc.prexcName.maxLength">
                                        This value is too long. It should have 500 characters or fewer.
                                    </span>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="prexcClass"
                                    >Program Cluster
                                </label>
                                <b-input-group>
                                    <template #append>
                                        <b-button @click="getPa" variant="outline-info">
                                            <i class="mdi mdi-clipboard-text-search-outline"></i>
                                        </b-button>
                                    </template>
                                    <input
                                        autocomplete="off"
                                        type="text"
                                        disabled
                                        placeholder="Search Program Cluster..."
                                        class="form-control"
                                        v-model="prexc.prexcClassification.classification"
                                    />
                                </b-input-group>
                                <div
                                    v-if="submitted && $v.prexc.prexcClassificationId.$error"
                                    class="invalid-feedback"
                                >
                                    <span v-if="!$v.prexc.prexcClassificationId.required">This value is required.</span>
                                </div>
                            </div>
                            <div class="mb-3" >
                                <label for="outcome"
                                    >Outcome
                                </label>
                                <b-input-group>
                                    <template #append>
                                        <b-button @click="getOM" variant="outline-info">
                                            <i class="mdi mdi-clipboard-text-search-outline"></i>
                                        </b-button>
                                    </template>
                                    <input
                                        autocomplete="off"
                                        type="text"
                                        disabled
                                        placeholder="Search Outcome..."
                                        class="form-control"
                                        v-model="prexc.outcome.outcomeName"
                                    />
                                </b-input-group>
                                <div
                                    v-if="submitted && $v.prexc.outcomeId.$error"
                                    class="invalid-feedback"
                                >
                                    <span v-if="!$v.prexc.outcomeId.required">This value is required.</span>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button
                                    type="submit"
                                    class="btn btn-primary"
                                >
                                    Save changes
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-link"
                                    @click="$bvModal.hide('pa-modal')"
                                >
                                    Close
                                </button>
                            </div>
                        </form>
                    </b-modal>
                </div>
            </div>
            <!-- End search -->
        </div>
        <div class="table-responsive mb-0">
            <b-table
                class="datatables"
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                :busy="tableBusy"
                @filtered="onFiltered"
                bordered
                outlined
                hover
                striped
                show-empty
                select-mode="single"
                selectable
                @row-selected="dropData"
                selected-variant="success"
            >
                <template #empty="scope">
                    <div class="text-center">{{ scope.emptyText }}</div>
                </template>
                <template #table-busy>
                    <div
                        class="d-flex justify-content-center align-items-center"
                    >
                        <div class="preloader-component me-2">
                            <div class="status">
                                <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                </div>
                            </div>
                        </div>
                        <strong>Loading...</strong>
                    </div>
                </template>
                <template #cell(prexcName)="row">
                    <div>
                        {{row.value}}
                        <small class="d-block">{{row.item.prexcClassification.classification}}</small>
                    </div>
                </template>
                <template #cell(actions)="row">
                    <div class="float-end">
                        <b-dropdown
                            id="dropdown-dropleft"
                            right
                            variant="link"
                            toggle-class="text-decoration-none"
                            menu-class="dropdown-menu-end"
                            no-caret
                        >
                            <template #button-content>
                                <i class="fas fa-ellipsis-v"></i>
                            </template>
                            <b-dropdown-item
                                @click="updateItem(row)"
                                variant="secondary"
                                ><i class="mdi mdi-update font-size-18 me-1"></i
                                >Edit</b-dropdown-item
                            >
                            <b-dropdown-item
                                @click="deleteItem(row)"
                                variant="danger"
                                ><i
                                    class="mdi mdi-trash-can font-size-18 me-1"
                                ></i
                                >Delete</b-dropdown-item
                            >
                        </b-dropdown>
                    </div>
                </template>
            </b-table>
        </div>
        <div class="row">
            <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                    <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
        <prexc-classification ref="pModal" @dropData="dropPrexcClass($event)"></prexc-classification>
        <outcome-modal ref="outcomeModal" @dropData="dropOutcome($event)"/>
    </b-modal>
</template>